/**
 * Replace named placeholders in a string with values from an object
 * Example: "Hello {name}, you have {count} messages" with {name: "John", count: 5}
 */
export const replaceTemplate = (
  template: string,
  values: Record<string, string | number | boolean>,
): string =>
  template.replace(/{(\w+)}/g, (match, key) =>
    key in values ? String(values[key]) : match,
  );
